import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core'
import { MatCardModule } from '@angular/material/card'

import { TranslateModule } from '@ngx-translate/core'

import { UserAccessComponent } from '~/core/components'
import { DestroyDirective } from '~/core/directives'
import {
  EForecastRisk,
  EGuardEntityName,
  EGuardSectionName,
  EPostReleaseRisk,
  IForecastDto,
} from '~/core/models'
import { ForecastNumber, ForecastPercentNumber } from '~/shared/pipes'

@Component({
  selector: 'app-stock-price-predictions-info',
  templateUrl: './stock-price-predictions-info.component.html',
  styleUrl: './stock-price-predictions-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [
    MatCardModule,
    ForecastNumber,
    TranslateModule,
    UserAccessComponent,
    ForecastPercentNumber,
  ],
})
export class StockPricePredictionsInfoComponent {
  readonly guardSectionName = input<EGuardSectionName | null>()
  readonly forecast = input<IForecastDto | null>(null)

  EForecastRisk = EForecastRisk
  postReleaseRisk = EForecastRisk.LOW
  EGuardEntityName = EGuardEntityName

  constructor() {
    effect(() => {
      const forecast = this.forecast()

      if (forecast) {
        this.setRisk()
      }

      return forecast
    })
  }

  private setRisk(): void {
    const forecast = this.forecast()

    if (!forecast) {
      return
    }

    if (forecast.postReleaseOvernightMove < EPostReleaseRisk.LOW) {
      this.postReleaseRisk = EForecastRisk.LOW
    } else if (forecast.postReleaseOvernightMove < EPostReleaseRisk.MEDIUM) {
      this.postReleaseRisk = EForecastRisk.MEDIUM
    } else if (forecast.postReleaseOvernightMove < EPostReleaseRisk.HIGH) {
      this.postReleaseRisk = EForecastRisk.HIGH
    } else {
      this.postReleaseRisk = EForecastRisk.VERY_HIGH
    }
  }
}
